<template>
    <div>
      <div class="col-md-12 card text-left">
        <div class="card-header"></div>
        <div class="report-filters" style="align-items: end;">
          <div class="col-md-3 col-sm-6 col-xs-12 form-group pull-left">
            <label class="form-label">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control" v-model="filters.location" @change="onLocationChange">
              <option v-for="(loc, index) in locations" :key="index" :label="loc.name" :value="loc.id">{{loc.name}}</option>
            </select>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12 form-group pull-left">
            <label class="form-label">{{$t('stock.product')}}</label>
            <el-select
              v-model="filters.product"
              class="w-100"
              filterable
              remote
              clearable
              :remote-method="searchProducts"
              :loading="loadingProducts"
              :disabled="!filters.location"
              :placeholder="$t('stock.productNamePlaceholder')"
              @change="onProductChange"
              style="width: 100%;"
            >
              <el-option
                v-for="product in productOptions"
                :key="product.id"
                :label="product.name + ' (#' + product.id + ')'"
                :value="product.id"
              ></el-option>
            </el-select>
          </div>
          <div class="search-button-reports form-group pull-left" style="margin-bottom: 34px;">
            <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" :class="{ disabled: !canSearch }" @click="getData(null)"><i class="ti-search"></i></div>
          </div>
          <div class="search-button-reports form-group pull-left" style="margin-bottom: 34px;">
            <div :title="$t('reports.export')" class="btn btn-icon btn-info btn-print" :class="{ disabled: !canSearch }" @click="exportData()"><i class="ti-file"></i></div>
          </div>
        </div>
        <div class="card-content total-pagination pad-15">
          <data-tables-server
              class=""
              @query-change="paginationChanged"
              v-loading="loading"
              :data="movementsTableData"
              :search-def="{ show: false }"
              :total="totalMovements"
              :pagination-props="paginationProps"
              :table-props="tableOptions"
              style="width: 100%;"
            >
            <el-table-column
              :min-width="60"
              prop="id"
              label="Id"
            ></el-table-column>
            <el-table-column :min-width="120" label="Data">
              <template slot-scope="props">
                <span>{{ props.row.created_at }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="100"
              prop="stock_movement"
              label="Cantitate stoc"
            ></el-table-column>
            <el-table-column
              :min-width="100"
              prop="old_stock"
              label="Stoc vechi"
            ></el-table-column>
            <el-table-column
              :min-width="100"
              prop="new_stock"
              label="Stoc nou"
            ></el-table-column>
            <el-table-column :min-width="140" :label="$t('reports.stockMovementType')">
              <template slot-scope="props">
                <span>{{ typeLabel(props.row.type) }}</span>
              </template>
            </el-table-column>
            <el-table-column :min-width="100" label="Comanda">
              <template slot-scope="props">
                <span>{{ props.row.order_id || props.row.order_app_id || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column :min-width="80" label="Optiune">
              <template slot-scope="props">
                <span>{{ props.row.is_option ? 'DA' : 'NU' }}</span>
              </template>
            </el-table-column>
            <el-table-column :min-width="140" label="Utilizator">
              <template slot-scope="props">
                <span>{{ props.row.user_name || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column :min-width="120" :label="$t('reports.stockMovementUserRole')">
              <template slot-scope="props">
                <span>{{ props.row.user_role || '-' }}</span>
              </template>
            </el-table-column>
          </data-tables-server>
        </div>
      </div>
    </div>
</template>
<script>
  import {Select, Option} from 'element-ui'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option
    },
    created () {
      this.verifyUserLocations()
    },
    data () {
      return {
        loading: false,
        loadingProducts: false,
        filters: {
          location: '',
          product: ''
        },
        locations: [],
        productOptions: [],
        paginationProps: {
          layout: 'prev, pager, next, sizes, total'
        },
        tableOptions: {},
        totalMovements: null,
        movementsTableData: []
      }
    },
    computed: {
      canSearch () {
        return !!this.filters.location && !!this.filters.product
      }
    },
    methods: {
      typeLabel (type) {
        if (parseInt(type) === 1) return this.$t('reports.stockMovementManualAdjustment')
        if (parseInt(type) === 2) return this.$t('reports.stockMovementOrderPlaced')
        return type
      },
      verifyUserLocations () {
        this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
          id: location.true_id,
          name: location.name
        }))

        if (!this.isOwner()) {
          let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))
          if (allowedLocations.length > 0) {
            this.locations = this.locations.filter(function (el) {
              return allowedLocations.includes(el.id)
            })
          }
        }

        if (this.locations.length) {
          this.filters.location = this.locations[0].id
          this.searchProducts('')
        }
      },
      onLocationChange () {
        this.filters.product = ''
        this.productOptions = []
        this.movementsTableData = []
        this.totalMovements = null
        if (this.filters.location) {
          this.searchProducts('')
        }
      },
      onProductChange () {
        this.movementsTableData = []
        this.totalMovements = null
        if (this.canSearch) {
          this.getData(null)
        }
      },
      searchProducts (search) {
        if (!this.filters.location) {
          return
        }

        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_id: this.filters.location,
          search: search,
          perPage: 50
        }

        this.loadingProducts = true
        this.apiRequest('/product-stocks/products-search', 'GET', data, response => {
          if (response.status === true) {
            this.productOptions = response.data
          }
          this.loadingProducts = false
        })
      },
      paginationChanged (query) {
        if (query.type === 'page') this.getData(query)
        if (query.type === 'size') this.getData(query)
      },
      buildParams () {
        return {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_id: this.filters.location,
          product_id: this.filters.product
        }
      },
      getData (query) {
        if (!this.canSearch) {
          return
        }

        const data = this.buildParams()

        this.loading = true
        const pageSize = query ? query.pageSize : 20
        const page = query ? query.page : 1
        this.apiRequest('/reports/stock-movements?page=' + page + '&pageSize=' + pageSize, 'GET', data, response => {
          if (response.status === true) {
            this.movementsTableData = response.data.data
            this.totalMovements = response.data.total
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })
      },
      exportData () {
        if (!this.canSearch) {
          return
        }

        const data = this.buildParams()

        this.loading = true
        this.apiRequest('/reports/stock-movements-export', 'GET', data, response => {
          if (response.status === true) {
            const link = document.createElement('a')
            link.href = response.data.file
            link.setAttribute('download', response.data.file_name)
            document.body.appendChild(link)
            link.click()
          }
          this.loading = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/StockMovements.vue